import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const agreementsStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 0.75,

    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,

  index: {
    color: 'gray.64',
    width: 24,
    textAlign: 'center',
  } as SxProps<Theme>,

  label: {
    color: 'info.main',
  } as SxProps<Theme>,
}
